import { render, staticRenderFns } from "./approvedProject.vue?vue&type=template&id=76540230&scoped=true&"
import script from "./approvedProject.vue?vue&type=script&lang=js&"
export * from "./approvedProject.vue?vue&type=script&lang=js&"
import style0 from "./approvedProject.vue?vue&type=style&index=0&id=76540230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76540230",
  null
  
)

export default component.exports